import { z } from "zod";

export const photoRouletteCandidateSchema = z.object({
	user_id: z.string(),
	display_name: z.string(),
	avatar_url: z.string().nullable(),
});

export type PhotoRouletteCandidate = z.infer<typeof photoRouletteCandidateSchema>;
